import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c2f0c9c")

_pushScopeId("data-v-6c2f0c9c")
const _hoisted_1 = { class: "pptist-screen" }
const _hoisted_2 = {
  class: "tools",
  id: "tools"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "上一页", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "下一页", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "备注视图", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "画笔", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScreenSlide = _resolveComponent("ScreenSlide")
  const _component_SlideThumbnails = _resolveComponent("SlideThumbnails")
  const _component_WritingBoardTool = _resolveComponent("WritingBoardTool")
  const _component_IconLeftTwo = _resolveComponent("IconLeftTwo")
  const _component_IconRightTwo = _resolveComponent("IconRightTwo")
  const _component_IconEditor = _resolveComponent("IconEditor")
  const _component_IconWrite = _resolveComponent("IconWrite")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: "slide-list",
      style: _ctx.preview === 'preview'?{
      }:{
      },
      onMousewheel: _cache[1] || (_cache[1] = $event => _ctx.mousewheelListener($event))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
        return (_openBlock(), _createBlock("div", {
          class: [
          'slide-item', 
          `turning-mode-${slide.turningMode || 'slideY'}`,
          {
            'current': index === _ctx.slideIndex,
            'before': index < _ctx.slideIndex,
            'after': index > _ctx.slideIndex,
            'hide': (index === _ctx.slideIndex - 1 || index === _ctx.slideIndex + 1) && slide.turningMode !== _ctx.currentSlide.turningMode,
          }
        ],
          key: slide.id
        }, [
          _createVNode("div", {
            class: "slide-content",
            style: _ctx.preview === 'preview'?{
            width: '100%',
            height: '100%',
          }:{
            width: _ctx.slideWidth + 'px',
            height: _ctx.slideHeight + 'px',
          }
          }, [
            _createVNode(_component_ScreenSlide, {
              slide: slide,
              scale: _ctx.scale,
              animationIndex: _ctx.animationIndex
            }, null, 8, ["slide", "scale", "animationIndex"])
          ], 4)
        ], 2))
      }), 128))
    ], 36), [
      [_directive_contextmenu, _ctx.contextmenus]
    ]),
    (_ctx.slideThumbnailModelVisible)
      ? (_openBlock(), _createBlock(_component_SlideThumbnails, {
          key: 0,
          turnSlideToIndex: _ctx.turnSlideToIndex,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.slideThumbnailModelVisible = false))
        }, null, 8, ["turnSlideToIndex"]))
      : _createCommentVNode("", true),
    (_ctx.writingBoardToolVisible)
      ? (_openBlock(), _createBlock(_component_WritingBoardTool, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.writingBoardToolVisible = false))
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "tool-btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.execPrev()))
      }, [
        _createVNode(_component_IconLeftTwo, {
          theme: "two-tone",
          fill: ['#111', '#fff']
        }),
        _hoisted_3
      ]),
      _createVNode("div", {
        class: "tool-btn",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.execNext()))
      }, [
        _createVNode(_component_IconRightTwo, {
          theme: "two-tone",
          fill: ['#111', '#fff']
        }),
        _hoisted_4
      ]),
      _createVNode("div", {
        class: "tool-btn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeWindow()))
      }, [
        (_ctx.preview !== 'preview')
          ? (_openBlock(), _createBlock(_component_IconEditor, {
              key: 0,
              theme: "two-tone",
              fill: ['#fff', '#fff']
            }))
          : _createCommentVNode("", true),
        _hoisted_5
      ]),
      _createVNode("div", {
        class: "tool-btn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.writingBoardToolVisible = true))
      }, [
        _createVNode(_component_IconWrite, {
          theme: "two-tone",
          fill: ['#111', '#fff']
        }),
        _hoisted_6
      ])
    ]),
    (_ctx.showPageNumber)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "page-number",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.slideThumbnailModelVisible = true))
        }, _toDisplayString(_ctx.slideIndex + 1) + " / " + _toDisplayString(_ctx.slides.length), 1))
      : _createCommentVNode("", true)
  ]))
})